import { Stack, Typography } from '@mui/material';
import Carousel from '../../components/carousel/Carousel';
import YouTubeVideoCard from './YouTubeVideoCard';

type YouTubeVideo = {
  id: string;
  title: string;
  videoId: string;
  thumbnailUrl: string;
}

type Props = {
  category: string;
  videos: YouTubeVideo[];
}

const YouTubeVideoSection = ({ category, videos }: Props) => {
    return (
        <Stack flexDirection="column" gap={4} margin={4}>
            <Typography variant="h3" fontSize="24px" fontWeight="600">{category}</Typography>
            <Carousel
                dots={false}
                infinite={false}
                slidesToShow={5}
                slidesToScroll={3}
            >
                {videos.map((video) => (
                    <YouTubeVideoCard
                        key={video.id}
                        id={video.id}
                        title={video.title}
                        videoId={video.videoId}
                        thumbnailUrl={video.thumbnailUrl}
                    />
                ))}
            </Carousel>
        </Stack>
    )
}

export default YouTubeVideoSection;